<script setup lang="ts">
import {
  ApiReference,
  parse,
  type ReferenceConfiguration,
} from '@scalar/api-reference'
import '@scalar/api-reference/style.css'
import { defu } from 'defu'

definePageMeta({
  layout: 'scalar',
})

const isDark = useDark()

useHead({
  bodyAttrs: {
    class: () => (isDark.value ? 'dark-mode' : 'light-mode'),
  },
})

const authToken = await useNuxtApp().$auth0().getAccessTokenSilently()
const { data: openapi } = await useFetch('/api/paapi/openapi')

const { origin } = useRequestURL()

const servers = [
  {
    url: `${origin}/api/paapi`,
    description: 'Admin proxy',
  },
]

const parsedSpec = reactive(await parse(openapi.value))
const rawSpec = computed(() => JSON.stringify(defu({ servers }, openapi.value)))

const config = computed<Partial<ReferenceConfiguration>>(() => ({
  baseServerURL: origin,
  _integration: 'nuxt',
  showSidebar: true,
  authentication: {
    preferredSecurityScheme: 'auth0-jwt-token',

    apiKey: {
      token: '',
    },
    http: {
      basic: {
        username: '',
        password: '',
      },
      bearer: {
        token: authToken,
      },
    },
  },

  darkMode: isDark.value,
  hiddenClients: [
    'libcurl',
    'clj_http',
    'httpclient',
    'restsharp',
    'native',
    'http1.1',
    'asynchttp',
    'nethttp',
    'okhttp',
    'unirest',
    'xhr',
    'jquery',
    'okhttp',
    'native',
    'request',
    'unirest',
    'nsurlsession',
    'cohttp',
    'guzzle',
    'http1',
    'webrequest',
    'restmethod',
    'requests',
    'httr',
    'native',
    'httpie',
    'wget',
    'nsurlsession',
    'undici',
  ],
  spec: {
    content: rawSpec.value,
  },
}))
</script>

<template>
  <ClientOnly>
    <ApiReference
      :configuration="config"
      :isDark="!!isDark"
      :parsedSpec="parsedSpec"
      :rawSpec="rawSpec"
      @toggleDarkMode="isDark = !isDark"
    />
  </ClientOnly>
</template>
